import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import H7 from 'UIComponents/elements/headings/H7';
import { GYPSUM, GREAT_WHITE } from 'HubStyleTokens/colors';
import UITile from 'UIComponents/tile/UITile';
const PanelSectionWrapper = styled.div.withConfig({
  displayName: "PanelSection__PanelSectionWrapper",
  componentId: "sc-16ptiha-0"
})(["margin-top:-1px;border-top:1px solid ", ";"], GREAT_WHITE);
const HeaderUITile = styled(UITile).withConfig({
  displayName: "PanelSection__HeaderUITile",
  componentId: "sc-16ptiha-1"
})(["padding:12px 20px;border:none;border-radius:0;background-color:", ";", ""], GYPSUM, props => props.showBorders && `border-bottom: 1px solid ${GREAT_WHITE};`);
const MarginlessH7 = styled(H7).withConfig({
  displayName: "PanelSection__MarginlessH7",
  componentId: "sc-16ptiha-2"
})(["margin:0;"]);
export const PanelSection = ({
  title,
  showBorders = true,
  children
}) => /*#__PURE__*/_jsxs(PanelSectionWrapper, {
  children: [/*#__PURE__*/_jsx(HeaderUITile, {
    showBorders: showBorders ? 1 : 0,
    children: /*#__PURE__*/_jsx(MarginlessH7, {
      children: title
    })
  }), children]
});
export default PanelSection;